import React from 'react';
import { Eye, FileText, Printer } from 'lucide-react';
import { Button } from '@/components/ui/button';

const PrintDocumentToolbar = ({
  onPreview,
  onSavePdf,
  onBrowserPrint,
  previewLoading = false,
  pdfSaving = false,
  printLoading = false,
}) => {
  return (
    <div className="flex flex-wrap items-center gap-1.5 rounded-md border border-border/60 bg-white/85 p-1.5 shadow-sm">
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="h-8 rounded-md px-2.5 text-xs"
        onClick={onPreview}
        disabled={previewLoading}
        data-testid="toolbar-preview"
      >
        <Eye className="h-4 w-4 me-2" /> {previewLoading ? 'Refreshing...' : 'Preview'}
      </Button>

      <Button
        type="button"
        variant="outline"
        size="sm"
        className="h-8 rounded-md px-2.5 text-xs"
        onClick={onSavePdf}
        disabled={pdfSaving}
        data-testid="toolbar-save-pdf"
      >
        <FileText className="h-4 w-4 me-2" /> {pdfSaving ? 'Saving PDF...' : 'Save as PDF'}
      </Button>

      <Button
        type="button"
        variant="outline"
        size="sm"
        className="h-8 rounded-md px-2.5 text-xs"
        onClick={onBrowserPrint}
        disabled={printLoading}
        data-testid="toolbar-browser-print"
      >
        <Printer className="h-4 w-4 me-2" /> {printLoading ? 'Preparing Print...' : 'Browser Print'}
      </Button>
    </div>
  );
};

export default PrintDocumentToolbar;